import { isBundledExperienceItem, isExperienceItem } from 'lib/checkout/checkoutUtils'
import { isExperienceUpsellSequence } from './experienceUpsell'

export function normaliseExperienceInflowBundleItems(items: Array<App.Checkout.AnyItem>): Array<App.Checkout.AnyItem> {
  const sequences = new Map<string, number>()
  let highest = 0
  for (const item of items) {
    if (!isExperienceItem(item) || item.metaData?.checkoutExperienceInflowBundle !== true) continue
    const sequence = item.metaData.checkoutExperienceInflowBundleSequence
    if (isExperienceUpsellSequence(sequence)) {
      sequences.set(item.experienceId, sequence)
      highest = Math.max(highest, sequence)
    }
  }
  let changed = false
  const normalised = items.map(item => {
    if (!isExperienceItem(item) || item.metaData?.checkoutExperienceInflowBundle !== true || item.metaData.checkoutExperienceInflowBundleSequence !== undefined) return item
    let sequence = sequences.get(item.experienceId)
    if (sequence === undefined) {
      highest += 1
      sequence = highest
      sequences.set(item.experienceId, sequence)
    }
    changed = true
    return { ...item, metaData: { ...item.metaData, checkoutExperienceInflowBundleSequence: sequence } }
  })
  return changed ? normalised : items
}

export function getExperienceInflowBundleOfferSequences(items: Array<App.Checkout.AnyItem>): Map<string, number> | undefined {
  const sequences = new Map<string, number>()
  const offers = new Map<number, string>()
  for (const item of items.filter(isExperienceItem)) {
    const marker = item.metaData?.checkoutExperienceInflowBundle
    const sequence = item.metaData?.checkoutExperienceInflowBundleSequence
    if (marker !== true) {
      if ((marker !== undefined && marker !== false) || sequence !== undefined) return undefined
      continue
    }
    if (!isExperienceUpsellSequence(sequence) || item.metaData?.checkoutExperienceUpsell === true || Boolean(isBundledExperienceItem(item))) return undefined
    const existingSequence = sequences.get(item.experienceId)
    const offer = offers.get(sequence)
    if ((existingSequence !== undefined && existingSequence !== sequence) || (offer !== undefined && offer !== item.experienceId)) return undefined
    sequences.set(item.experienceId, sequence)
    offers.set(sequence, item.experienceId)
  }
  return sequences
}
